import { useEffect, useState, useRef } from "react";
import { getToken, getUserId, getInizioPeriodo,getFinePeriodo } from "../auth";
import funzione_collegamento from "../funzioni_server/pacchetti_lez_function.js";
import lezioni from "../funzioni_server/lesson_function.js";
import convertDate from "../funzioni/converti_data";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUsers, faLock,faPencil, faTrashCan,faCircleInfo,faSpinner } from "@fortawesome/free-solid-svg-icons";
import "../stili/tabelle.css";
import ReactDOM from "react-dom/client";
import "../stili/popup.css";
import  nome_id  from "../funzioni/nome_id";
import  status_lezione  from "../funzioni/status_lezione";
import  differenzaOrario  from "../funzioni/differenza_ore";
import { DateTime } from 'luxon';
import {istruttori_disponibili,decodificaNazionalita,aggiungiTempo,criptaRuolo,decriptaRuolo} from "../funzioni/funzioni_utili"
import Lottie from "lottie-react";
import animLoading from "../assets/loading.json";
import animLoading2 from "../assets/loading2.json";
/* global $ */
const TabellaLezioni =({data}) =>{
const inizioP=DateTime.fromISO(getInizioPeriodo()).toFormat("yyyyMMdd")
const fineP=DateTime.fromISO(getFinePeriodo()).plus({days:1}).toFormat("yyyyMMdd")
function truncate(num, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.trunc(num * factor) / factor;
}
function closePacket(pacchetto){
    const contenuto =document.createElement("div")
    contenuto.style.padding = "0px";
    contenuto.innerText = `Sei sicuro di volere chiudere il pacchetto di ${pacchetto.nome}?`
    contenuto.style.marginTop = "10px";
    contenuto.style.fontSize = "20px";
    contenuto.style.fontFamily = "Poppins, sans-serif";
    $("#chiusuraPacchetto").dxPopup("instance").option( "title",`Conferma chiusura pacchetto di ${pacchetto.nome}`);
    $("#chiusuraPacchetto").dxPopup("instance").option("contentTemplate", () => contenuto);
    $("#chiusuraPacchetto").dxPopup("instance").option( "toolbarItems", [{
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        stylingMode: 'contained',
        text: 'Salva',
        onClick: async function () {
            $("#loadingOverlay").show()
            const dati={"lessonpacket":truncate(pacchetto.oreTot,2)};
            const  richiesta= await funzione_collegamento({
                userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        valori:dati,
        setId:pacchetto.lessonid,
        azione:'setLesson'
            })
      $("#gridContainer").addClass("grid-container-hidden");
      const grid = $("#gridContainer").dxDataGrid("instance");

// prendi tutte le righe attualmente visualizzate
const rows = grid.getVisibleRows();

// trova l'indice della riga con quel lessonid
const rowIndex = rows.findIndex(r => r.data.lessonid === pacchetto.lessonid);
  grid.cellValue(rowIndex, "lessonpacket", truncate(pacchetto.oreTot, 2));
      $("#gridContainer").removeClass("grid-container-hidden");
      $("#chiusuraPacchetto").dxPopup("instance").hide();

            }
      },
    }, {
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        text: 'Chiudi',
        stylingMode: 'outlined',
        type: 'normal',
        onClick() {
          $("#chiusuraPacchetto").dxPopup("instance").hide();
        },
      },
    }],)
    $("#chiusuraPacchetto").dxPopup("instance").show();
}
async function dynamicLessonButton( cellInfo) {
    $("#loadingOverlay").show();
          const content = await mostraPopupInfoLezione(
            cellInfo.lessonid,cellInfo.nome
          );

          $("#loadingOverlay").hide();  // Nasconde overlay
          $("#infoPopup").dxPopup("instance").option(
            "title",
            `Dettagli lezioni di ${cellInfo.nome}`
          );
          $("#infoPopup").dxPopup("instance").option("contentTemplate", () => content);
          $("#infoPopup").dxPopup("instance").show();

}

async function mostraPopupInfoLezione(id,nome) {
  const allineamento="center"
  const lez_pac_gen = await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione:"getLessonDates",
    filtri: { lessonid: id,},
  });
  let lez_pac=[]
  let lez_pach_prog=[]
  for (let i of lez_pac_gen){
    if (i.lessondatestatus===2){
        lez_pac.push(i)
    }
    else if (i.lessondatestatus===1){
        lez_pach_prog.push(i)
    }
  }
  const utenti = await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione:'getUsers'
  });
  const formattedRows2 = lez_pac.map((row, index) => ({
    id: index,
    lessondateid:row.lessondateid,
    inizio: convertDate(row.lessondatestart).toISO({ includeOffset: false }),
    fine: convertDate(row.lessondateend).toISO({ includeOffset: false }),
    durata: convertDate(row.lessondateend)-convertDate(row.lessondatestart),
    istruttore: nome_id({id:row.userid, utenti:utenti}),
    status: status_lezione(row.lessondatestatus),
    livello: row.lessondatelevelreached,
  }));
  const formattedRows3 = lez_pach_prog.map((row, index) => ({
    id: index,
    lessondateid:row.lessondateid,
    inizio: convertDate(row.lessondatestart).toISO({ includeOffset: false }),
    fine: convertDate(row.lessondateend).toISO({ includeOffset: false }),
    durata: convertDate(row.lessondateend)-convertDate(row.lessondatestart),
    istruttore: nome_id({id:row.userid, utenti:utenti}),
    status: status_lezione(row.lessondatestatus),
    livello: row.lessondatelevelreached,
  }));
  const div = document.createElement("div");
  div.style.padding = "0px";
  const titolo1=document.createElement("h3")
  titolo1.innerText="Ore concluse"
  titolo1.style.fontFamily = "Poppins, sans-serif";
  titolo1.style.marginBottom="0px"
  div.appendChild(titolo1)
  const inner = document.createElement("div");
  inner.id = "gridContainerSecond";
  div.appendChild(inner);
  const titolo2=document.createElement("h3")

  titolo2.innerText="Ore Programmate"
  titolo2.style.fontFamily = "Poppins, sans-serif";
  titolo2.style.marginBottom="0px"
  if (lez_pach_prog.length!==0)
  div.appendChild(titolo2)
  if (lez_pach_prog.length!==0){
  const inner2=document.createElement("div");
  inner2.id = "gridContainerSecondProg";

  div.appendChild(inner2);}
  const commento = document.createElement("p");
  let totale_ore=0
  let totale_ore_prog=0
  for (let i of lez_pac) {const diffMs = convertDate(i.lessondateend)-convertDate(i.lessondatestart);
  totale_ore+=diffMs}
  for (let i of lez_pach_prog) {const diffMs = convertDate(i.lessondateend)-convertDate(i.lessondatestart);
  totale_ore+=diffMs
  totale_ore_prog+=diffMs}
  if (totale_ore_prog===0)
  commento.innerText = `Ore totali di ${nome}: ${differenzaOrario({dataInizio:totale_ore})}`
  else commento.innerText = `Ore totali di ${nome}: ${differenzaOrario({dataInizio:totale_ore})}, di cui ${differenzaOrario({dataInizio:totale_ore-totale_ore_prog})} concluse e ${differenzaOrario({dataInizio:totale_ore_prog})} programmate`
  commento.style.marginTop = "10px";
  commento.style.fontWeight = "bold";
  commento.style.fontSize = "24px";
  commento.style.fontFamily = "Poppins, sans-serif";
  div.appendChild(commento);
  setTimeout(() => {
    $("#gridContainerSecond").dxDataGrid({
      dataSource: formattedRows2,
      columns: [
        {
          dataField: "inizio",
          caption: "Data e ora inizio",
          hidingPriority:5,
          alignment:allineamento,
          customizeText: function (e) {
            return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy HH:mm");
          },
          editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_inizio").length===0) {
                $('<div id="val_inizio"></div>').appendTo(cellElement)
            }
            $("#val_inizio").dxDateBox({type:"datetime",format: "dd/MM/yyyy HH:mm",displayFormat :"dd/MM/yyyy HH:mm",value:cellInfo.value, onValueChanged: function(e) {
            cellInfo.setValue(e.value)

            }})
          }
        },
        { dataField: "fine", alignment:allineamento,caption: "Data e ora fine", hidingPriority:4,customizeText: function (e) {
            return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy HH:mm");
          }, editorType: 'dxDateBox',
            editorOptions: {
            displayFormat: "dd/MM/yyyy",
  },},
        { dataField: "durata", alignment:allineamento,caption: "Durata lezione",hidingPriority:6,customizeText: function (e) {

            return differenzaOrario({dataInizio:e.value},);
          },
          editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_durata_lez").length===0) {
                $('<div id="val_durata_lez"></div>').appendTo(cellElement)
            }
            const diffMin_or = Math.floor(cellInfo.value / 60000); // millisecondi in minuti
            const ore_ad = Math.floor(diffMin_or / 60);
            const minuti_ad = diffMin_or % 60;
            $("#val_durata_lez").dxTextBox({mask:'0:00',value: minuti_ad<10 ? `${ore_ad}:0${minuti_ad}`:`${ore_ad}:${minuti_ad}` , onValueChanged: function(e) {
            const durationString = e.value;
            const hours = parseInt(durationString[0])
            const minutes =parseInt(durationString.slice(1, 3))
            const valoreInMs = (hours * 60 + minutes) * 60000;
            cellInfo.setValue(valoreInMs);

            }})
          }
        },
        { dataField: "istruttore",alignment:allineamento, caption: "Istruttore" ,hidingPriority:3,

        editCellTemplate: async function  (cellElement,cellInfo) {
          if ($("#val_istruttore").length===0) {
                $('<div id="val_istruttore"></div>').appendTo(cellElement)
            }
             const rowData = cellInfo.row.data;
            const ora_in=$("#val_inizio").dxDateBox("instance").option("value")
            const durat=$("#val_durata_lez").dxTextBox("instance").option("value")
            const utenti = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                azione:'getUsers'
              });
            const istruttoriDisponibili= await istruttori_disponibili({dataInizio:DateTime.fromISO(ora_in).toMillis(),dataFine:DateTime.fromISO(ora_in).toMillis()+rowData.durata,id_lezione:lez_pac[rowData.id]?.lessondateid ?? 0,utenti:utenti});
            $("#val_istruttore").dxSelectBox({dataSource:istruttoriDisponibili , value:rowData.istruttore,onValueChanged: function(e) {
            cellInfo.setValue(e.value)},
            elementAttr: {
                class: "istruttore-style"
              },
            })
          },
        },
        { dataField: "status",alignment:allineamento, caption: "Status Lezione", hidingPriority:2,
         editCellTemplate: function  (cellElement,cellInfo) {
          if ($("#val_status").length===0) {
                $('<div id="val_status"></div>').appendTo(cellElement)
            }
            const dati_id_c=[{ID:1,name:"Programmata"},{ID:2,name:"Conclusa"},{ID:3,name:"Cancellata"},{ID:4,name:"No Show"}]
            $("#val_status").dxSelectBox({dataSource: dati_id_c,displayExpr:"name",valueExpr:"ID", value:status_lezione(cellInfo.value),

            onValueChanged: function(e) {
            cellInfo.setValue(e.value)},
            elementAttr: {
                class: "istruttore-style"
              }
            },)

          }},
        { dataField: "livello",alignment:allineamento, caption: "Livello raggiunto", hidingPriority:1 },
        {
            type: "buttons",
            minWidth:120,
            buttons: [
              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => cellInfo.component.editRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },

              {
                hint: "Elimina",
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },]}
      ],
      showBorders: true,
      scrolling: { useNative: true },
      rowAlternationEnabled: true,
      columnAutoWidth: true,
      paging: { pageSize: 50 },
      height: "auto",
      width: "auto",
      columnHidingEnabled: true,
      editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            width:"70%",
            height:"auto",
            maxHeight:"90%",
            title: `Modifica lezione di ${nome}`,
            showTitle: true,
          },
          form: {
            items: [
              {
                itemType: "group",
                colCount: 2,
                colSpan: 2,
                items: [
                "inizio","durata","istruttore","status",
                ],
              },
              {
                itemType: "group",
                colCount: 1,
                colSpan: 2,
                items: ["livello"
                ],
              },
            ],
          },
          },
    onRowUpdated: async function (e) {
    const gridElement = $("#gridContainerSecond"); // Ottieni l'intera griglia

        // Aggiungi la classe di animazione alla griglia
        gridElement.addClass("table-updated");

        // Rimuovi la classe dopo l'animazione
        setTimeout(() => {
            gridElement.removeClass("table-updated");
        }, 1000);
     const jsDate = new Date(e.data.inizio);
    const baseDate2 = DateTime.fromJSDate(jsDate)
    const basedate2iso=baseDate2.toISO({ includeOffset: false })
    const baseDate=DateTime.fromISO(basedate2iso,{ zone: "Africa/Nairobi" })
    const updatedDate = baseDate.plus({ milliseconds:e.data.durata });
    const istruttore=nome_id({nome:e.data.istruttore,utenti:utenti})
    let statusLez
    if (typeof e.data.status==="string"){ statusLez=status_lezione(e.data.status)}
    else { statusLez=(e.data.status)}
    const dati_n={"lessondatestart":convertDate(DateTime.fromISO(baseDate),false,true),"lessondateend":convertDate(updatedDate,false,true),"userid":istruttore,"lessondatestatus":statusLez,"lessondatelevelreached":e.data.livello,};
    const richiesta = await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        setId:e.data.lessondateid,
        valori:dati_n,
        azione:'setLessonDate'})
        if (richiesta) {
            const message = `Lezione di ${nome} modificata con successo`;

            window.DevExpress.ui.notify({message,
            position: {
              my: 'center',
              at: 'center',
              of: '#gridContainerSecond',
            },}, "success", 1000);
            let totale_ore=0
            for (let i of lez_pac) {const diffMs = convertDate(i.lessondateend)-convertDate(i.lessondatestart);
            totale_ore+=diffMs}
            totale_ore+=(e.data.durata-(convertDate(lez_pac[e.data.id]["lessondateend"])-convertDate(lez_pac[e.data.id]["lessondatestart"])))
            commento.innerText =  `Ore totali di ${nome}: ${differenzaOrario({dataInizio:totale_ore})}`
        }

    },

    onRowRemoving: async function (e) {

    const richiesta=  await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        delId:e.data.lessondateid,
        azione:'delLessonDate',
        return_data:false})
    if (richiesta) {
        const message = `Lezione di ${nome} eliminata con successo`;
        window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainerSecond',
        },}, "success", 1000);}


},
    onRowInserting: async function (e) {

        // Aggiungi la classe di animazione alla griglia
        $("#loadingOverlay").show();
         $("#gridContainerSecond").addClass("grid-container-hidden");


    const jsDate = new Date(e.data.inizio);
    const baseDate2 = DateTime.fromJSDate(jsDate)
    const basedate2iso=baseDate2.toISO({ includeOffset: false })
    const baseDate=DateTime.fromISO(basedate2iso,{ zone: "Africa/Nairobi" })
    const updatedDate = baseDate.plus({ milliseconds:e.data.durata });
    const istruttore=nome_id({nome:e.data.istruttore,utenti:utenti})
    const dati={"lessonid":id,"lessondatestart":convertDate(DateTime.fromISO(baseDate),false,true),"lessondateend":convertDate(updatedDate,false,true),"userid":istruttore,"lessondatestatus":e.data.status,"lessondatelevelreached":e.data.livello,};
    const richiesta= await  funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        valori:dati,
        azione:'setLessonDate'})
    if (richiesta) {
        const message = `Lezione di ${nome} aggiunto con successo`;

  window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainerSecond',

        },}, "success", 1000);
        const lez_pac = await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione:"getLessonDates",
    filtri: { lessonid: id,lessondatestatus:2 },
  });
      const formattedRows2 = lez_pac.map((row, index) => ({
    id: index,
    inizio: convertDate(row.lessondatestart).toISO({ includeOffset: false }),
    fine: convertDate(row.lessondateend).toISO({ includeOffset: false }),
    durata: convertDate(row.lessondateend)-convertDate(row.lessondatestart),
    istruttore: nome_id({id:row.userid, utenti:utenti}),
    status: status_lezione(row.lessondatestatus),
    livello: row.lessondatelevelreached,
  }));
  let totale_ore=0
  for (let i of lez_pac) {const diffMs = convertDate(i.lessondateend)-convertDate(i.lessondatestart);
  totale_ore+=diffMs}
  commento.innerText =  `Ore totali di ${nome}: ${differenzaOrario({dataInizio:totale_ore})}`
      e.component.option("dataSource", formattedRows2);
      setTimeout(() => {
            $("#gridContainerSecond").removeClass("grid-container-hidden");
            $("#loadingOverlay").hide();
        }, 100);
        }
    },
    onCellClick: function(e) {
                if (e.event.target && e.event.target.classList.contains("dx-datagrid-adaptive-more")) {

      const masterRow = e.component.getRowElement(e.row.rowIndex);
      const $icon = masterRow.find(".dx-datagrid-adaptive-more.custom-icon-expanded");
      if (!($icon.length)) {
      const masterRow = e.component.getRowElement(e.row.rowIndex);
      const $icon = masterRow.find(".dx-datagrid-adaptive-more");
      if ($icon.length){
      $icon[0].className = "dx-datagrid-adaptive-more custom-icon-expanded";}
      }
      else
      {
      $icon[0].className = "dx-datagrid-adaptive-more";
      }}

    },

    });
    if (totale_ore_prog!==0){
    $("#gridContainerSecondProg").dxDataGrid({
      dataSource: formattedRows3,
      columns: [
        {
          dataField: "inizio",
          caption: "Data e ora inizio",
          hidingPriority:5,
          alignment:allineamento,
          customizeText: function (e) {
            return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy HH:mm");
          },
          editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_inizio").length===0) {
                $('<div id="val_inizio"></div>').appendTo(cellElement)
            }
            $("#val_inizio").dxDateBox({type:"datetime",format: "dd/MM/yyyy HH:mm",displayFormat :"dd/MM/yyyy HH:mm",value:cellInfo.value, onValueChanged: function(e) {
            cellInfo.setValue(e.value)

            }})
          }
        },
        { dataField: "fine", alignment:allineamento,caption: "Data e ora fine", hidingPriority:4,customizeText: function (e) {
            return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy HH:mm");
          }, editorType: 'dxDateBox',
            editorOptions: {
            displayFormat: "dd/MM/yyyy",
  },},
        { dataField: "durata", alignment:allineamento,caption: "Durata lezione",hidingPriority:6,customizeText: function (e) {

            return differenzaOrario({dataInizio:e.value},);
          },
          editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_durata_lez").length===0) {
                $('<div id="val_durata_lez"></div>').appendTo(cellElement)
            }
            const diffMin_or = Math.floor(cellInfo.value / 60000); // millisecondi in minuti
            const ore_ad = Math.floor(diffMin_or / 60);
            const minuti_ad = diffMin_or % 60;
            $("#val_durata_lez").dxTextBox({mask:'0:00',value: minuti_ad<10 ? `${ore_ad}:0${minuti_ad}`:`${ore_ad}:${minuti_ad}` , onValueChanged: function(e) {
            const durationString = e.value;
            const hours = parseInt(durationString[0])
            const minutes =parseInt(durationString.slice(1, 3))
            const valoreInMs = (hours * 60 + minutes) * 60000;
            cellInfo.setValue(valoreInMs);

            }})
          }
        },
        { dataField: "istruttore",alignment:allineamento, caption: "Istruttore" ,hidingPriority:3,

        editCellTemplate: async function  (cellElement,cellInfo) {
          if ($("#val_istruttore").length===0) {
                $('<div id="val_istruttore"></div>').appendTo(cellElement)
            }
             const rowData = cellInfo.row.data;
            const ora_in=$("#val_inizio").dxDateBox("instance").option("value")
            const durat=$("#val_durata_lez").dxTextBox("instance").option("value")
            const utenti = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                azione:'getUsers'
              });
            const istruttoriDisponibili= await istruttori_disponibili({dataInizio:DateTime.fromISO(ora_in).toMillis(),dataFine:DateTime.fromISO(ora_in).toMillis()+rowData.durata,id_lezione:lez_pac[rowData.id]?.lessondateid ?? 0,utenti:utenti});
            $("#val_istruttore").dxSelectBox({dataSource:istruttoriDisponibili , value:rowData.istruttore,onValueChanged: function(e) {
            cellInfo.setValue(e.value)},
            elementAttr: {
                class: "istruttore-style"
              },
            })
          },
        },
        { dataField: "status",alignment:allineamento, caption: "Status Lezione", hidingPriority:2,
         editCellTemplate: function  (cellElement,cellInfo) {
          if ($("#val_status").length===0) {
                $('<div id="val_status"></div>').appendTo(cellElement)
            }
            const dati_id_c=[{ID:1,name:"Programmata"},{ID:2,name:"Conclusa"},{ID:3,name:"Cancellata"},{ID:4,name:"No Show"}]
            $("#val_status").dxSelectBox({dataSource: dati_id_c,displayExpr:"name",valueExpr:"ID", value:status_lezione(cellInfo.value),

            onValueChanged: function(e) {
            cellInfo.setValue(e.value)},
            elementAttr: {
                class: "istruttore-style"
              }
            },)

          }},
        { dataField: "livello",alignment:allineamento, caption: "Livello raggiunto", hidingPriority:1 },
        {
            type: "buttons",
            minWidth:80,
            buttons: [
              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => cellInfo.component.editRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
              {
                hint: "Elimina",
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },]}
      ],
      showBorders: true,
      scrolling: { useNative: true },
      rowAlternationEnabled: true,
      columnAutoWidth: true,
      paging: { pageSize: 50 },
      height: "auto",
      width: "auto",
      columnHidingEnabled: true,
      editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            width:"70%",
            height:"auto",
            maxHeight:"90%",
            title: `Modifica lezione di ${nome}`,
            showTitle: true,
          },
          form: {
            items: [
              {
                itemType: "group",
                colCount: 2,
                colSpan: 2,
                items: [
                "inizio","durata","istruttore","status",
                ],
              },
              {
                itemType: "group",
                colCount: 1,
                colSpan: 2,
                items: ["livello"
                ],
              },
            ],
          },
          },
    onRowUpdated: async function (e) {
    const gridElement = $("#gridContainerSecond"); // Ottieni l'intera griglia

        // Aggiungi la classe di animazione alla griglia
        gridElement.addClass("table-updated");

        // Rimuovi la classe dopo l'animazione
        setTimeout(() => {
            gridElement.removeClass("table-updated");
        }, 1000);
     const jsDate = new Date(e.data.inizio);
    const baseDate2 = DateTime.fromJSDate(jsDate)
    const basedate2iso=baseDate2.toISO({ includeOffset: false })
    const baseDate=DateTime.fromISO(basedate2iso,{ zone: "Africa/Nairobi" })
    const updatedDate = baseDate.plus({ milliseconds:e.data.durata });
    const istruttore=nome_id({nome:e.data.istruttore,utenti:utenti})
    let statusLez
    if (typeof e.data.status==="string"){ statusLez=status_lezione(e.data.status)}
    else { statusLez=(e.data.status)}
    const dati_n={"lessondatestart":convertDate(DateTime.fromISO(baseDate),false,true),"lessondateend":convertDate(updatedDate,false,true),"userid":istruttore,"lessondatestatus":statusLez,"lessondatelevelreached":e.data.livello,};
    const richiesta = await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        setId:e.data.lessondateid,
        valori:dati_n,
        azione:'setLessonDate'})
        if (richiesta) {
            const message = `Lezione di ${nome} modificata con successo`;

            window.DevExpress.ui.notify({message,
            position: {
              my: 'center',
              at: 'center',
              of: '#gridContainerSecond',
            },}, "success", 1000);
            let totale_ore=0
            for (let i of lez_pac) {const diffMs = convertDate(i.lessondateend)-convertDate(i.lessondatestart);
            totale_ore+=diffMs}
            totale_ore+=(e.data.durata-(convertDate(lez_pac[e.data.id]["lessondateend"])-convertDate(lez_pac[e.data.id]["lessondatestart"])))
            commento.innerText =  `Ore totali di ${nome}: ${differenzaOrario({dataInizio:totale_ore})}`
        }

    },

    onRowRemoving: async function (e) {

    const richiesta=  await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        delId:e.data.lessondateid,
        azione:'delLessonDate',
        return_data:false})
    if (richiesta) {
        const message = `Lezione di ${nome} eliminata con successo`;
        window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainerSecond',
        },}, "success", 1000);}


},
    onRowInserting: async function (e) {

        // Aggiungi la classe di animazione alla griglia
        $("#loadingOverlay").show();
         $("#gridContainerSecond").addClass("grid-container-hidden");


    const jsDate = new Date(e.data.inizio);
    const baseDate2 = DateTime.fromJSDate(jsDate)
    const basedate2iso=baseDate2.toISO({ includeOffset: false })
    const baseDate=DateTime.fromISO(basedate2iso,{ zone: "Africa/Nairobi" })
    const updatedDate = baseDate.plus({ milliseconds:e.data.durata });
    const istruttore=nome_id({nome:e.data.istruttore,utenti:utenti})
    const dati={"lessonid":id,"lessondatestart":convertDate(DateTime.fromISO(baseDate),false,true),"lessondateend":convertDate(updatedDate,false,true),"userid":istruttore,"lessondatestatus":e.data.status,"lessondatelevelreached":e.data.livello,};
    const richiesta= await  funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        valori:dati,
        azione:'setLessonDate'})
    if (richiesta) {
        const message = `Lezione di ${nome} aggiunto con successo`;

  window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainerSecond',

        },}, "success", 1000);
        const lez_pac = await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione:"getLessonDates",
    filtri: { lessonid: id,lessondatestatus:2 },
  });
      const formattedRows3 = lez_pach_prog.map((row, index) => ({
    id: index,
    inizio: convertDate(row.lessondatestart).toISO({ includeOffset: false }),
    fine: convertDate(row.lessondateend).toISO({ includeOffset: false }),
    durata: convertDate(row.lessondateend)-convertDate(row.lessondatestart),
    istruttore: nome_id({id:row.userid, utenti:utenti}),
    status: status_lezione(row.lessondatestatus),
    livello: row.lessondatelevelreached,
  }));
  let totale_ore=0
  for (let i of lez_pac) {const diffMs = convertDate(i.lessondateend)-convertDate(i.lessondatestart);
  totale_ore+=diffMs}
  commento.innerText =  `Ore totali di ${nome}: ${differenzaOrario({dataInizio:totale_ore})}`
      e.component.option("dataSource", formattedRows3);
      setTimeout(() => {
            $("#gridContainerSecond").removeClass("grid-container-hidden");
            $("#loadingOverlay").hide();
        }, 100);
        }
    },
    onCellClick: function(e) {
                if (e.event.target && e.event.target.classList.contains("dx-datagrid-adaptive-more")) {

      const masterRow = e.component.getRowElement(e.row.rowIndex);
      const $icon = masterRow.find(".dx-datagrid-adaptive-more.custom-icon-expanded");
      if (!($icon.length)) {
      const masterRow = e.component.getRowElement(e.row.rowIndex);
      const $icon = masterRow.find(".dx-datagrid-adaptive-more");
      if ($icon.length){
      $icon[0].className = "dx-datagrid-adaptive-more custom-icon-expanded";}
      }
      else
      {
      $icon[0].className = "dx-datagrid-adaptive-more";
      }}

    },

    });}

  }, 0);

  return div;
}

function BounceIconButton({ icon, onClick, color = "#000" }) {
  const [isClicked, setIsClicked] = useState(false);


  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 800);
    onClick();
  };

  return (
    <button
      style={{
        cursor: "pointer",
        padding: "5px",
        background: "none",
        border: "none",
        color: color,
      }}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={icon} className={isClicked ? "fa-bounce" : ""} />
    </button>
  );
}
const TabellaPacchetti = ({data}) => {
  const gridRef = useRef(null);
  const listinoPrezzi={"Base":{1:80,2:150,3:210,4:270,5:320,6:390,7:440,8:490,9:540,10:570},"Avanzata":{1:90,2:170,3:240,4:300,5:360,6:420,7:450,8:520,9:570,10:600},"Foil":{1:90,2:170,3:240,4:300,5:360,6:420,7:450,8:520,9:570,10:600}}
  const allineamento="center"
  useEffect(() => {
    const fetchPacchetti =  () => {
       $("#loadingOverlay").show();
      $("#gridContainer").addClass("grid-container-hidden")

      let categorieTotali={}
      let dataSourceNazionalita=[]
      for (let pacchetto of data){
        if (!(pacchetto.lessonstudentorigin in categorieTotali))categorieTotali[pacchetto.lessonstudentorigin]=0
        categorieTotali[pacchetto.lessonstudentorigin]+=1
      }
      for (let nazione in categorieTotali){
        if (parseInt(nazione)!==0)
        dataSourceNazionalita.push({category:decodificaNazionalita(parseInt(nazione)),valore:categorieTotali[nazione]})
      }
      let categorieTotaliGeneri={}
      let dataSourceGeneri=[]
      for (let pacchetto of data){
        if (!(pacchetto.lessonstudentsex in categorieTotaliGeneri))categorieTotaliGeneri[pacchetto.lessonstudentsex]=0
        categorieTotaliGeneri[pacchetto.lessonstudentsex]+=1
      }
      for (let sesso in categorieTotaliGeneri){
        if (parseInt(sesso)!==0)
        dataSourceGeneri.push({category:parseInt(sesso)===1?"Uomo":"Donna",valore:categorieTotaliGeneri[sesso]})
      }
      const formattedRows = data.map((row, index) => ({
        id: index,
        lessonid:row.lessonid,
        data: convertDate(row.lessonregdate).toISO({ includeOffset: false }),
        nome: row.lessonstudentname,
        pacchetto: row.lessonpacket,
        tipo: row.lessontype,
        costo: row.lessoncost,
        gruppoSingola: row.lessonnumstudents,
        pagamento: row.lessonpaymentmethod,
        anticipo: row.lessonadvance,
        sconto:row.lessondiscount,
        telefono:row.lessonstudentphone,
        sesso:row.lessonstudentsex,
        eta:row.lessonstudentage,
        origine:row.lessonstudentorigin,
        periodo:[row.lessonclientarrival,row.lessonclientdeparture],
        nonDisp:row.lessonclientunavailable,
        costo_scontato: (row.lessoncost * (1 - (row.lessondiscount || 0) / 100)),
        oreTot:row.lessonhours,
      }));
      // Inizializza dxDataGrid
      $("#gridContainer").dxDataGrid({
        dataSource: formattedRows,
        columns: [
          {
            dataField: "data",
            caption: "Data",
            sortOrder: "desc",
             hidingPriority:8,
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_reg").length===0) {
                $('<div id="val_reg"></div>').appendTo(cellElement)
            }
            $("#val_reg").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value,onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            }})
          },
            calculateFilterExpression: function(filterValue, selectedFilterOperation) {
              if (!filterValue) return null;
              if (selectedFilterOperation === "between" && Array.isArray(filterValue)) {
                const isoStart = DateTime.fromJSDate(filterValue[0]).toISO({ includeOffset: false });
                const isoEnd = DateTime.fromJSDate(filterValue[1]).toISO({ includeOffset: false });
                return [
                  [this.dataField, ">=", isoStart],
                  "and",
                  [this.dataField, "<=", isoEnd]
                ];
              }
              if (selectedFilterOperation === "<") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, "<=", isoStart]
              }
              if (selectedFilterOperation === ">") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, ">=", isoStart]
              }
              const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
              return [this.dataField, "=", isoStart]
            },
          customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }
          },
          { dataField: "nome", caption: "Studente", hidingPriority: 13,alignment:allineamento, },
          {
            dataField: "pacchetto",
            hidingPriority: 12,
            caption: "Pacchetto",
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_pacchetto").length===0) {
                $('<div id="val_pacchetto"></div>').appendTo(cellElement)
            }
            $("#val_pacchetto").dxNumberBox({min:0,step:0.5,value:cellInfo.value,elementAttr: {
        inputmode: "decimal"   // forza tastiera con separatore decimale
    },format:"#0.#'H'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            const tipo_lez=$("#val_tipo").dxSelectBox("instance").option("value")
            const n_ore=($("#val_pacchetto").dxNumberBox("instance").option("value"))
            $("#val_costo").dxNumberBox("instance").option("value",listinoPrezzi[tipo_lez][n_ore])

            }})
          },
            customizeText: function (e) {
              return `${e.value}H`;}
          },
          { dataField: "tipo", caption: "Tipo", alignment:allineamento,hidingPriority: 11,editCellTemplate: function(cellElement,cellInfo) {
          if ($("#val_tipo").length===0) {
                $('<div id="val_tipo"></div>').appendTo(cellElement)
            }
          const dataTipo=[{ID:"Base",name:"Base"},{ID:"Avanzata",name:"Avanzata"},{ID:"Foil",name:"Foil"}]
          $("#val_tipo").dxSelectBox({dataSource:dataTipo,valueExpr: 'name',displayExpr: 'name',value:cellInfo.value,searchEnabled: true, onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            const tipo_lez=$("#val_tipo").dxSelectBox("instance").option("value")
            const n_ore=($("#val_pacchetto").dxNumberBox("instance").option("value"))
            $("#val_costo").dxNumberBox("instance").option("value",listinoPrezzi[tipo_lez][n_ore])
            },
            })
          }},
          {
            dataField: "gruppoSingola",
            hidingPriority: 6,
            caption: "Num",
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_num").length===0) {
                $('<div id="val_num"></div>').appendTo(cellElement)
            }
            $("#val_num").dxNumberBox({min:1,step:1,value:cellInfo.value, onValueChanged: function(e) {
            cellInfo.setValue(e.value)

            }})
          },
            cellTemplate: (cellElement, cellInfo) => {
              const icon = cellInfo.value === 1 ? faUser : faUsers;
              const root = ReactDOM.createRoot(cellElement.get(0));
              root.render(
                <span>
                  <FontAwesomeIcon icon={icon} /> {cellInfo.value}
                </span>
              );
            },
          },
          {
            dataField: "costo",
            caption: "Costo",
            alignment:allineamento,
            hidingPriority: 10,
            calculateDisplayValue: function(rowData) {
    return rowData.costo_scontato ?? rowData.costo;
  },
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_costo").length===0) {
                $('<div id="val_costo"></div>').appendTo(cellElement)
            }
            $("#val_costo").dxNumberBox({min:0,value:cellInfo.value,elementAttr: {
        inputmode: "decimal"   // forza tastiera con separatore decimale
    },format:"#0.##'€'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            const sconto_att=$("#val_sconto").dxNumberBox("instance").option("value")
            $("#val_costo_scontato").dxNumberBox("instance").option("value",cellInfo.value*(1-sconto_att/100))

            }})
          },
            customizeText: function (e) {
              const val = typeof e.value === 'number' ? e.value : 0;
              return `${val.toFixed(2)} €`;
            }
          },
          {
            dataField: "anticipo",
            caption: "Anticipo",
            hidingPriority: 9,
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_anticipo").length===0) {
                $('<div id="val_anticipo"></div>').appendTo(cellElement)
            }
            $("#val_anticipo").dxNumberBox({min:0,value:cellInfo.value,elementAttr: {
        inputmode: "decimal"   // forza tastiera con separatore decimale
    },format:"#0.##'€'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})
          },
            customizeText: function (e) {
              const val = typeof e.value === 'number' ? e.value : 0;
              return `${val.toFixed(2)} €`;
            }
          },
          { dataField: "pagamento", caption: "Pagamento", hidingPriority: 1,alignment:allineamento, },
          { dataField: "origine", caption: "Nazionalità allievo", hidingPriority: 2,alignment:allineamento,
          customizeText:function(e){
            return decodificaNazionalita(e.value)
          },
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_origine").length===0) {
                $('<div id="val_origine"></div>').appendTo(cellElement)
            }
            let valore_mappa=[]
            let contatore=0
            while (decodificaNazionalita(contatore)){
                valore_mappa.push({name:decodificaNazionalita(contatore),ID:contatore})
                contatore+=1
            }
            $("#val_origine").dxSelectBox({dataSource:valore_mappa ,valueExpr:"ID",displayExpr:"name", value:cellInfo.value,onValueChanged: function(e) {
            cellInfo.setValue(e.value)},
            elementAttr: {
                class: "istruttore-style"
              },
            })
          }
           },
           {
           dataField: "periodo",
            caption: "Periodo",
            alignment:allineamento,
            hidingPriority: 7,
            calculateDisplayValue: function(rowData) {
                let stringa=""
                if (rowData["periodo"]){
               if (rowData["periodo"][0] && rowData["periodo"][0]){
                    stringa=`dal ${DateTime.fromFormat(rowData["periodo"][0],"yyyyMMdd").toFormat("dd/MM/yyyy")} al ${DateTime.fromFormat(rowData["periodo"][1],"yyyyMMdd").toFormat("dd/MM/yyyy")}`

               }}
               return stringa
            },
            editCellTemplate: function(cellElement,cellInfo){
                if ($("#val_periodo").length===0) {
                    $('<div id="val_periodo"></div>').appendTo(cellElement)
                }
                const start = cellInfo["data"]["periodo"][0] ? DateTime.fromFormat(cellInfo["data"]["periodo"][0], "yyyyMMdd").toJSDate() : null;
                const end = cellInfo["data"]["periodo"][1] ? DateTime.fromFormat(cellInfo["data"]["periodo"][1], "yyyyMMdd").toJSDate() : null;
                $("#val_periodo").dxDateRangeBox({
                startDate: start,
                endDate: end,
                displayFormat: "dd/MM/yyyy",
                startDateLabel: "Arrivo",
                endDateLabel: "Partenza",
                showClearButton: true,
                openOnFieldClick: true,
                onValueChanged: function(e) {
                    if (!e.value) return;
                    const [newStart, newEnd] = e.value;
                    cellInfo.setValue([(newStart)?!(isNaN(newStart.getTime()))?DateTime.fromJSDate(newStart).toFormat("yyyyMMdd"):null:null,(newEnd)?!(isNaN(newEnd.getTime()))?DateTime.fromJSDate(newEnd).toFormat("yyyyMMdd"):null:null])
                }
            });
            }
           },
           {
            dataField: "nonDisp",
            caption: "Date non disponibili",
            visible: false, // colonna nascosta
            editCellTemplate: function(cellElement, cellInfo) {
            if ($("#tagBoxContainer").length===0) {
                $('<div id="tagBoxContainer"></div>').appendTo(cellElement)
            }
            let dateG=cellInfo.value
            let dateCont=[]
            let stringaDate=[]

            if (dateG){
                stringaDate=dateG.split(",");
            }
            for (let data of stringaDate){
                if (data)
               dateCont.push(DateTime.fromFormat(data,"yyyyMMdd").toFormat("dd/MM/yyyy"))
            }
                $("#tagBoxContainer").dxTagBox({
    items: [],
        value:   dateCont,
        placeholder: "Date non disponibili",
        showSelectionControls: true,
        acceptCustomValue: true,
        noDataText: "",
        showSelectionControls: false,
        dropDownOptions: {
    contentTemplate: function(e) {
         const selectedDates = ( $("#tagBoxContainer").dxTagBox("instance").option("value")).map(d => {
            const parts = d.split("/"); // dd/MM/yyyy
            return new Date(parts[2], parts[1]-1, parts[0]);
        });
        const $calendarDiv = $('<div id="myCalendar"></div>').css({
    width: "auto",
});
        $calendarDiv.dxCalendar({
            selectionMode: "multiple",
            value: selectedDates,
            onValueChanged: function(calenEvent) {
                if (!calenEvent.value) return;
                const dataS = calenEvent.value.map(date => {
                    return DateTime.fromJSDate(date).toFormat("dd/MM/yyyy")
                });
                $("#tagBoxContainer").dxTagBox("instance").option("value", dataS);
            }
        });

        return $calendarDiv;
    }
},
        onValueChanged: function(e) {
        if ($("#myCalendar").dxCalendar("instance")){
            const selectedDates = ( $("#tagBoxContainer").dxTagBox("instance").option("value")).map(d => {
            const parts = d.split("/"); // dd/MM/yyyy
            return new Date(parts[2], parts[1]-1, parts[0]);})
        if ($("#myCalendar").dxCalendar("instance").option("value").length!==selectedDates.length)
        $("#myCalendar").dxCalendar("instance").option("value",selectedDates)
        let listaM=""
        for (let data of $("#tagBoxContainer").dxTagBox("instance").option("value")){
            listaM+=DateTime.fromFormat(data,"dd/MM/yyyy").toFormat("yyyyMMdd")+","
        }
        cellInfo.setValue(listaM)
        console.log(listaM)
        }


    }
});
            }
        },
           { dataField: "eta", caption: "Età allievo", hidingPriority: 3,alignment:allineamento,
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_eta").length===0) {
                $('<div id="val_eta"></div>').appendTo(cellElement)
            }
            $("#val_eta").dxNumberBox({min:0,value:cellInfo.value,format:"#0.##' anni'",onValueChanged: function(e) {
            cellInfo.setValue(e.value)},
            })
          }
           },
           { dataField: "sesso", caption: "Genere allievo", hidingPriority: 4,alignment:allineamento,
          customizeText:function(e){
             const mappa={0:"Non specificato",1:"Uomo",2:"Donna"}
            return mappa[e.value]
          },
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_sesso").length===0) {
                $('<div id="val_sesso"></div>').appendTo(cellElement)
            }
            const valore_mappa=[{name:"Non specificato",ID:0},{name:"Uomo",ID:1},{name:"Donna",ID:2}]
            $("#val_sesso").dxSelectBox({dataSource:valore_mappa ,valueExpr:"ID",displayExpr:"name", value:cellInfo.value,onValueChanged: function(e) {
            cellInfo.setValue(e.value)},
            elementAttr: {
                class: "istruttore-style"
              },
            })
          }
           },
           { dataField: "telefono", caption: "Numero allievo", hidingPriority: 5,alignment:allineamento, },

          {dataField: "sconto",visible:false,editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_sconto").length===0) {
                $('<div id="val_sconto"></div>').appendTo(cellElement)
            }
            $("#val_sconto").dxNumberBox({showSpinButtons: true,step:5,min:0,elementAttr: {
        inputmode: "decimal"   // forza tastiera con separatore decimale
    },value:cellInfo.value,max:100,format:"#0.##'%'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            const valore_nuovo=($("#val_costo").dxNumberBox("instance").option("value"))*(1-cellInfo.value/100)
            $("#val_costo_scontato").dxNumberBox("instance").option("value",valore_nuovo)
            }})
          }},
          {dataField: "costo_scontato",visible:false,
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_costo_scontato").length===0) {
                $('<div id="val_costo_scontato"></div>').appendTo(cellElement)
            }

            const displV=($("#val_costo").dxNumberBox("instance").option("value"))*(1-($("#val_sconto").dxNumberBox("instance").option("value"))/100)
            $("#val_costo_scontato").dxNumberBox({showSpinButtons: true,step:10,min:0,elementAttr: {
        inputmode: "decimal"   // forza tastiera con separatore decimale
    },value:displV,format:"#0.##'€'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            $("#val_costo_scontato").dxNumberBox("instance").option("max",$("#val_costo").dxNumberBox("instance").option("value"))
            const valore_nuovo=(1-(e.value)/($("#val_costo").dxNumberBox("instance").option("value")))*100
            $("#val_sconto").dxNumberBox("instance").option("value",valore_nuovo)
            }})
          }
          },
          {
            type: "buttons",
            minWidth:140,
            buttons: [
              {
                hint: "Modifica",
                icon: "edit",
                onClick: function (e) {
                  e.component.editRow(e.row.rowIndex);
                },

              },
              {
                hint: "Chiudi pacchetto",
                icon: "lock",
                onClick: function (e) {
                  closePacket(e.row.data)
                },
              },
              {
                hint: "Elimina",
                icon: "trash",
                onClick: function (e) {
                  e.component.deleteRow(e.row.rowIndex);
                },

              },
                {
                    hint: "Dettagli lezioni",
                    icon: "info",
                    onClick: async function(e){
                        dynamicLessonButton(e.row.data)
                    }
                }
            ],
          },
        ],
        showBorders: true,
        scrolling:{
        useNative:true
        },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        paging: { pageSize: 50 },
        height: "auto",
        width: "100%",
        columnHidingEnabled: true,
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: 'Search...',
        },
        filterRow: {
          visible: true,
          applyFilter: 'auto',
        },
        editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            title: "Informazioni studente",
            showTitle: true,
            width:"80%",
            height:"auto",
            maxHeight:"90%",
            onShown: function(e) {
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScroll" style="height: 100%; max"></div>');
    $("#customScroll").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    });
}
          },
          form: {
            items: [
              {
                itemType: "group",
                colCount: 2,
                colSpan: 2,
                items: [
                  "data",
                  "nome",
                  {
                    dataField: "pacchetto",
                    label: { text: "Pacchetto (H)" }  // ← Etichetta personalizzata
                  },
                  "tipo","periodo","nonDisp",
                  "gruppoSingola",
                  {
                    dataField: "costo",
                    label: { text: "Costo (€)" }  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "anticipo",
                    label: { text: "Pagato (€)" }  // ← Etichetta personalizzata
                  },
                  "pagamento","telefono","eta","sesso","origine",
                   {
          dataField: "sconto",
          label: {
            text: "Sconto (%)",
          }
        },
        {
          dataField: "costo_scontato",
          label: {
            text: "Costo scontato",
          }
        }
                ],
              },
            ],
          },
        },
        onCellClick: function(e) {
                if (e.event.target && e.event.target.classList.contains("dx-datagrid-adaptive-more")) {

  const masterRow = e.component.getRowElement(e.row.rowIndex);
  const $icon = masterRow.find(".dx-datagrid-adaptive-more.custom-icon-expanded");
  if (!($icon.length)) {
  const masterRow = e.component.getRowElement(e.row.rowIndex);
  const $icon = masterRow.find(".dx-datagrid-adaptive-more");
  if ($icon.length){
  $icon[0].className = "dx-datagrid-adaptive-more custom-icon-expanded";}
  }
  else
  {
  $icon[0].className = "dx-datagrid-adaptive-more";
  }}

},
    onEditorPreparing: function(e) {
  if (e.parentType === "filterRow" && e.dataField === "data") {

    e.editorName = "dxDateBox";  // Forza DateBox come filtro
    e.editorOptions = {
      displayFormat: "dd/MM/yyyy",
      type: "date",
      width: "100%",
      onValueChanged: function(ev) {
        e.setValue(ev.value);  // Applica il filtro
      }
    };
  }
},

    onInitNewRow: function (e) {
  e.data.costo = 0;
  e.data.anticipo=0
  e.data.data = DateTime.now().toISODate();
  e.data.tipo="Base"
  e.data.gruppoSingola=1
  e.data.sconto=0
  e.data.pacchetto=1
  e.data.periodo=[null,null]
},
    onRowRemoving: async function (e) {
    const richiesta=  await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        delId:e.data.lessonid,
        azione:'delLesson',
        return_data:false})
    if (richiesta) {
        const message = `Pacchetto di ${e.data.nome} eliminato con successo`;
        window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainer',
        },}, "success", 1000);}


},

    onRowInserting: async function (e) {

        // Aggiungi la classe di animazione alla griglia
        $("#loadingOverlay").show();
         $("#gridContainer").addClass("grid-container-hidden");

        // Rimuovi la classe dopo l'animazione

    const dati={"lessonregdate":convertDate(DateTime.fromISO(e.data.data)),"lessonclientarrival":e["data"]["periodo"][0],"lessonclientdeparture":e["data"]["periodo"][1],"lessonclientunavailable":e.data.nonDisp,"lessonstudentname":e.data.nome,"lessonadvance":e.data.anticipo,"lessoncost":e.data.costo,"lessonnumstudents":e.data.gruppoSingola,"lessonpaymentmethod":e.data.pagamento,"lessontype":e.data.tipo,"lessonpacket":e.data.pacchetto,"lessonstudentphone":e.data.telefono,"lessonstudentsex":e.data.sesso,"lessonstudentorigin":e.data.origine,"lessonstudentage":e.data.eta!==0?e.data.eta:null,"lessondiscount":e.data.sconto};
    const richiesta= await  funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        valori:dati,
        azione:'setLesson'})
    if (richiesta) {
        const message = `Pacchetto di ${e.data.nome} aggiunto con successo`;

  window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainer',
        },}, "success", 1000);
        window.location.reload()
        }
    },
    onRowUpdated: async function (e) {
    const gridElement = $("#gridContainer"); // Ottieni l'intera griglia

        // Aggiungi la classe di animazione alla griglia
        gridElement.addClass("table-updated");

        // Rimuovi la classe dopo l'animazione
        setTimeout(() => {
            gridElement.removeClass("table-updated");
        }, 1000);
    console.log(e)
    const dati_n={'lessondiscount':e.data.sconto,"lessonclientarrival":e["data"]["periodo"][0],"lessonclientdeparture":e["data"]["periodo"][1],"lessonclientunavailable":e.data.nonDisp,"lessonstudentphone":e.data.telefono,"lessonstudentsex":e.data.sesso,"lessonstudentorigin":e.data.origine,"lessonstudentage":e.data.eta!==0?e.data.eta:null,'lessonstudentname':e.data.nome,'lessonregdate':convertDate(DateTime.fromISO(e.data.data)),'lessonpacket':e.data.pacchetto,'lessontype':e.data.tipo,'lessoncost':e.data.costo,'lessonnumstudents':e.data.gruppoSingola,'lessonpaymentmethod':e.data.pagamento,'lessonadvance':e.data.anticipo};
    const richiesta = await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        setId:e.data.lessonid,
        valori:dati_n,
        azione:'setLesson'})
        if (richiesta) {
        const message = `Pacchetto di ${e.data.nome} modificato con successo`;

  window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainer',
        },}, "success", 1000);
        }
    },
        onRowPrepared: function (e) {
            setTimeout(() => {
                $("#gridContainer").removeClass("grid-container-hidden");
                $("#loadingOverlay").hide();},500)
          if (e.rowType === "data" && e.rowElement && e.data) {
            const parseEuro = (val) =>
              parseFloat(String(val).replace("€", "").replace(",", ".").replace(/\s/g, ""));

            const anticipo = parseEuro(e.data.anticipo);
            const costo = parseEuro(e.data.costo_scontato);

            if (!isNaN(anticipo) && !isNaN(costo) && Math.abs(anticipo - costo) > 0.01) {
              e.rowElement.addClass("row-warning");
              $(e.rowElement).css("background-color", "#ffe6e6")
            }
          }
        },
      });
      console.log(dataSourceNazionalita)
      $("#chartPieNazionalita").dxPieChart({
  dataSource: dataSourceNazionalita,
  width:"50%",
  height:"100%",
  tooltip: {
    enabled: true,
    customizeTooltip: function (pointInfo) {
      return {
        html: `
          <div style="padding: 5px; font-size: 14px;">
            <b>Categoria:</b> ${pointInfo.argument}<br>
            <b>Valore:</b> ${pointInfo.value} persone <br>
            <b>Percentuale:</b> ${pointInfo.percentText}
          </div>
        `,
      };}
    },
  series: {

    argumentField: "category",
    valueField: "valore",
    label: {
      visible: true,
      connector: {
        visible: false,
      },
    },
  },
  export: {
    enabled: true,
    formats: ['PNG', 'PDF', 'JPEG', 'SVG'],
    fileName: "grafico",
  },
  title: "Suddivisione nazionalità",
});
$("#chartPieGeneri").dxPieChart({
  dataSource: dataSourceGeneri,
  width:"50%",
  height:"100%",
  tooltip: {
    enabled: true,
    customizeTooltip: function (pointInfo) {
      return {
        html: `
          <div style="padding: 5px; font-size: 14px;">
            <b>Categoria:</b> ${pointInfo.argument}<br>
            <b>Valore:</b> ${pointInfo.value} persone <br>
            <b>Percentuale:</b> ${pointInfo.percentText}
          </div>
        `,
      };}
    },
  series: {

    argumentField: "category",
    valueField: "valore",
    label: {
      visible: true,
      connector: {
        visible: false,
      },
    },
  },
  export: {
    enabled: true,
    formats: ['PNG', 'PDF', 'JPEG', 'SVG'],
    fileName: "grafico",
  },
  title: "Suddivisione genere",
});
    };

    fetchPacchetti();
    $("#chiusuraPacchetto").dxPopup({
    width: "60%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
    });
    $("#infoPopup").dxPopup({
    width: "80%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
    hideOnOutsideClick: true,
    showCloseButton: true,
    onShown: function(e) {
    const $content = $(e.component.content());
    const $scroll = $("#customScroll");

    if ($scroll.length) {
        if ($scroll.data("dxScrollView")) {
            $scroll.dxScrollView("instance").dispose();
        }
        $scroll.remove();
    }

    $content.wrapInner('<div id="customScroll" style="height: 100%;"></div>');
    $("#customScroll").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    });
}

});

  }, []);

  return (

    <div id="gridContainer" ref={gridRef}></div>
  );
}
return (<div id="app" style={{ padding: "0px" }}>

    <TabellaPacchetti data={data} />
    <div id="chiusuraPacchetto" />
    <div style={{padding:"30px"}} id="infoPopup">
      <div className="popup-content">
      </div>
    </div>
    <div id="loadingOverlay">
      <div className="spinner">
        <Lottie  style={{ width: "100%", height: "100%" }} animationData={animLoading2} loop={true} />
      </div>
    </div>
  </div>)
}

export default TabellaLezioni;
